import { LoggingService } from "../loggingSvc";
import { UserTenantService } from "../user-tenant-service";
import { NavbarRegistrationServiceImplementation } from "../navigation/navbar-registration-service";

export const waitingState = "sdSystem.waiting";
export class EntryStateService {
  // @ngInject
  constructor(
    private userTenantService: UserTenantService,
    private $state: ng.ui.IStateService,
    private loggingService: LoggingService,
    private navbarRegistrationService: NavbarRegistrationServiceImplementation,
    private $q: ng.IQService
  ) {}

  /**
   * Navigates to the entry state
   */
  public goToEntryState(): void {
    let navPromise = this.$state.go(waitingState);
    let capturedEntry: string;
    let entryStatePromise = this.getEntryState().then((entryState) => (capturedEntry = entryState));
    this.$q.all([entryStatePromise, navPromise]).finally(() => {
      if (capturedEntry && this.$state.current.name == waitingState) {
        this.$state.go(capturedEntry);
      } else {
        this.loggingService.logWarning("Route navigation suppressed due to lack of home state.");
      }
    });
  }

  /**
   * Gets the entry state would be navigated to
   */
  public getEntryState(): ng.IPromise<string> {
    return this.navbarRegistrationService.getDefaultUIRef().then((uiRef: any) => {
      if (uiRef) {
        return uiRef;
      }

      if (this.userTenantService.isUserOnLegacyAuthTenant() && this.$state.get("comm")) {
        return "comm";
      }

      if (this.$state.get("home")) {
        return "home";
      }

      return undefined;
    });
  }
}
